module.exports = __webpack_public_path__ + "img/environment_outdoor1.37c84952.jpg";